<nz-drawer
	[nzClosable]="false"
	[(nzVisible)]="filtersDrawer"
	nzPlacement="right"
	(nzOnClose)="filtersDrawer = false"
	[nzTitle]="'common_filters-title' | translate"
	nzWidth="300"
>
    <hpf-category-filters [searchParams]="searchParams" [resetPage]="true"></hpf-category-filters>
</nz-drawer>
<hpf-category-list-top-bar
    [title]="'category_common_name' | translate"
	(filterEvent)="filtersDrawer = true"
	[searchParams]="searchParams"
	(createEvent)="onCreate()"
    [createButton]="'common_create' | translate"
    [showQuickSearch]="true"
    [quickSearchTooltip]="'common_search-by' | translate: { list: 'name' }"
    [quickSearchPlaceholder]="'common_quick-search' | translate"
    [showAdvancedSearch]="true"
></hpf-category-list-top-bar>
<div class="container-fluid px-5">
    <div class="row my-5">
        <div class="col-12">
            <hpf-category-table
                [searchParams]="searchParams"
                [enableMultiSelect]="true"
                [showActions]="true"
                (select)="onSelect($event)"></hpf-category-table>
        </div>
    </div>
</div>
